const CLOSE_MARK_SELECTOR = '.topVoice__quoteMark--close';
const DEFAULT_MAX_LENGTH = 110;
const ELLIPSIS = '…';

function getQuoteBodyText(el) {
	const clone = el.cloneNode(true);
	const closeMark = clone.querySelector(CLOSE_MARK_SELECTOR);
	if (closeMark) closeMark.remove();
	return clone.textContent.trim();
}

/**
 * TOP お客様の声：引用文を指定文字数で切り詰め（閉じ引用符は維持）
 * @param {Element | Document} root
 * @param {number} maxLength
 */
export function truncateTopVoiceQuotes(root = document, maxLength = DEFAULT_MAX_LENGTH) {
	const container =
		root instanceof Element
			? root.closest('.topVoice') || root
			: document.querySelector('.topVoice');
	if (!container) return;

	container.querySelectorAll('.js-top-voice-quote').forEach((el) => {
		if (el.dataset.truncated === 'true') return;

		const closeMark = el.querySelector(CLOSE_MARK_SELECTOR);
		const fullText = el.dataset.fullText || getQuoteBodyText(el);
		el.dataset.fullText = fullText;
		el.dataset.charCount = String(fullText.length);

		if (fullText.length <= maxLength) {
			el.dataset.truncated = 'true';
			return;
		}

		const truncated = `${fullText.slice(0, maxLength)}${ELLIPSIS}`;
		el.textContent = '';
		el.appendChild(document.createTextNode(truncated));
		if (closeMark) el.appendChild(closeMark);
		el.dataset.truncated = 'true';
	});

	if (import.meta.env.DEV && !container.dataset.voiceQuoteLogged) {
		container.dataset.voiceQuoteLogged = 'true';
		const rows = [...container.querySelectorAll('.js-top-voice-quote')].map((el, i) => ({
			index: i + 1,
			chars: el.dataset.charCount,
			truncated: Number(el.dataset.charCount) > maxLength,
			preview: el.dataset.fullText?.slice(0, 30),
		}));
		if (rows.length) console.table(rows);
	}
}
